import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { domain } from "config.js";

import style from "./style.module.scss";
import { HiSearch } from "react-icons/hi";

import Select from "./Components/Select";

function WelcomePage({ text, short, search }) {
    const [rawOptions, setRawOptions] = useState(null);
    const [location, setLocation] = useState([]);
    const [rerender, setRerender] = useState(false);

    const history = useHistory();
    const pathLocation = useLocation();


    const optionsTops = {
        type: ["Type"],
        region: ["Regio"],
        location: ["Locatie", "Choose region first"],
        bedrooms: ["Slaapkamers"],
        from: ["Prijs vanaf"],
        to: ["Prijs tot"]
    };

    const [options, setOptions] = useState(optionsTops);
    const [chosens, setChosens] = useState({});

    useEffect(() => {
        fetch(domain + "/int-getSearchOptions").then(response => {
            response.json().then(json => {
                let ops = { ...optionsTops };
                ops.type = [...ops.type, ...json?.types];

                let region = Object.keys(json?.regions);
                ops.region = [...ops.region, ...region];

                ops.bedrooms = [...ops.bedrooms, ...json?.bedrooms];


                let prices = getPrices(json.prices);
                ops.from = [optionsTops.from[0], ...prices];
                ops.to = [optionsTops.to[0], ...prices];

                setOptions(ops);
                setRawOptions(json);
            });
        });
    }, []);

    function getPrices(prices) {

        var pric = prices.from;
        var newpricelist = [];

        if (pric != prices.to) {

            const formatter = new Intl.NumberFormat("en-us", { style: "decimal" });
            const monetize = (mn) => formatter.format(mn) + " €";

            var pricestep = 100000;
            var pricTo = 1000000;

            while (pric + pricestep <= pricTo) {
                newpricelist.push(monetize(pric));
                pric += pricestep;
            }

            pricestep = 1000000;
            pric = 1000000;
            while (pric + pricestep < prices.to) {
                newpricelist.push(monetize(pric));
                pric += pricestep;
            }
            newpricelist.push(monetize(prices.to));
        }


        return newpricelist;
    }

    useEffect(() => {
        console.log("CHOSENS", chosens);
        if (chosens.region) {
            setOptions({ ...options, location: [optionsTops.location[0], ...rawOptions.regions[chosens.region]] });
        }
    }, [chosens.region]);

    function startSearch(){
        var params = {};
        params.ref = chosens.ref || "";
        params.type = chosens.type || "";
        params.region = chosens.region || "";
        params.location = chosens.location || "";
        params.bedrooms = chosens.bedrooms || "";
        params.from = chosens.from || "";
        params.to = chosens.to || "";

        history.push(pathLocation.pathname + "/results?" + (new URLSearchParams(params)).toString());

    }

    return (
        <div className={style.root}>
            <div className={style.topText}>
                <div>{text.topText[0]}</div>
                <div>{text.topText[1]}</div>
                <div>{text.topText[2]}</div>
            </div>

            <div className={style.middleContainer}>
                <div className={style.middleText}>
                    <div>{text.middleText[0]}</div>
                    <div className={short ? style.middleTitleShort : ""} >{text.middleText[1]}</div>
                    <div>{text.middleText[2]}</div>
                </div>
            </div>

            {
                search && <div className={style.searchArea}>
                    <div>SEARCH PROPERTIES</div>
                    <div className={style.searchFormCnt}>
                        <div>
                            <input placeholder="Reference" onChange={e => setChosens({ ...chosens, ref: e.target.value })} />
                        </div>
                        {Object.keys(options).map(
                            key => <div key={key}>
                                <Select options={options[key]} locationFirst={options.location[0]} param={key} chosenState={{ chosens, setChosens }} />
                            </div>
                        )}
                        <div className={style.searchButton} onClick={startSearch}>
                            <HiSearch size="33" />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default WelcomePage;